import { Card, CardContent } from '@/components/ui/card';

const Stats = ({ stats }) => {
  if (!stats) return null;

  const statCards = [
    {
      label: 'Total Hours',
      value: stats.total_hours.toFixed(1),
      icon: '⏱️',
      gradient: 'from-emerald-400 to-teal-500',
      testId: 'total-hours-stat'
    },
    {
      label: 'Sessions',
      value: stats.total_sessions,
      icon: '📊',
      gradient: 'from-teal-400 to-cyan-500',
      testId: 'total-sessions-stat'
    },
    {
      label: 'Avg Session',
      value: `${stats.average_session_minutes.toFixed(0)}m`,
      icon: '📈',
      gradient: 'from-cyan-400 to-blue-500',
      testId: 'avg-session-stat'
    },
    {
      label: 'Streak',
      value: `${stats.current_streak_days}d`,
      icon: '🔥',
      gradient: 'from-orange-400 to-red-500',
      testId: 'streak-stat'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="stats-section">
      {statCards.map((stat, index) => (
        <Card
          key={index}
          data-testid={stat.testId}
          className="backdrop-blur-sm bg-white/90 border-emerald-200 shadow-lg hover:shadow-xl transition-shadow"
        >
          <CardContent className="p-6">
            <div className={`w-12 h-12 bg-gradient-to-br ${stat.gradient} rounded-xl flex items-center justify-center mb-3 shadow-lg`}>
              <span className="text-2xl">{stat.icon}</span>
            </div>
            <div className="text-3xl font-bold text-emerald-900 mb-1">
              {stat.value}
            </div>
            <div className="text-sm text-emerald-600">
              {stat.label}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default Stats;